import tagularModule from '../../store/helpers/tagular.js'
import uuidv4 from 'uuid/v4'

//
// grab hero tiles from homepage hero section
////
const heroToolbar = document.querySelector('[data-homepage-toolbar]')
const heroTiles = [].slice.call(
  heroToolbar.querySelectorAll('[data-card-component]')
)

//
// If tiles exist, iterate and append the appropriate information
// to tagular webElement. Create click and pass events for click
// tracking on each tile element
////
if (heroTiles) {
  heroTiles.forEach((element, index) => {
    // Get home equity tile selector
    const isHomeEquityTile = element.querySelector('[data-tagular-click]')
      .dataset.tagularClick

    // Update HE tile href with uuid
    if (isHomeEquityTile === 'Home Equity') {
      const homeEquityTile = element.querySelector('[data-tagular-click]')

      homeEquityTile.setAttribute(
        'href',
        homeEquityTile.href +
          '?br_mi=999&app=bankrate-cobrand&correlationId=' +
          uuidv4()
      )
    }

    const text = element.querySelector('a').innerHTML.trim()
    const actionOutcome = `link to "${text}"`
    const outboundUrl = element.querySelector('a').getAttribute('href')

    const webElement = {
      location: 'Homepage hero tiles',
      position: `${index + 1}`,
      elementType: 'tile',
      text: text,
      htmlId: ''
    }

    element.addEventListener('click', () => {
      tagularModule.elementClicked(webElement, actionOutcome, outboundUrl)
    })
  })
}

//
// Create account section element clicked tracking
////
const createAccountCta = document.querySelector('[data-create-account-cta]')

if (createAccountCta) {
  createAccountCta.addEventListener('click', () => {
    const text = createAccountCta.innerHTML.trim()
    const actionOutcome = 'link to sign up page'
    const outboundUrl = createAccountCta.getAttribute('href')

    const webElement = {
      location: 'homepage',
      position: 'top',
      elementType: 'button',
      text: text,
      htmlId: ''
    }

    tagularModule.elementClicked(webElement, actionOutcome, outboundUrl)
  })
}
